import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL, getAuthHeaders } from '../utils/api';

function HelpChatPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [projectName, setProjectName] = useState('Zagger Product Help');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const headers = await getAuthHeaders();
        const infoResp = await fetch(`${API_BASE_URL}/casc/v1/api/help/info`, { headers });
        const infoJson = await infoResp.json().catch(() => ({}));
        if (!infoResp.ok || !infoJson?.success) {
          throw new Error(infoJson?.error || 'Failed to load help configuration');
        }

        const projectId = infoJson.data?.projectId;
        const name = infoJson.data?.projectName || 'Zagger Product Help';
        if (!cancelled) setProjectName(name);

        if (!projectId) {
          throw new Error(
            infoJson?.error ||
            'Product help could not be initialized. Confirm SUPABASE_SERVICE_ROLE_KEY is set on the server and check logs for "Product help bootstrap".'
          );
        }

        const sessionResp = await fetch(`${API_BASE_URL}/casc/v1/api/chat/session/create`, {
          method: 'POST',
          headers: { ...headers, 'Content-Type': 'application/json' },
          body: JSON.stringify({
            project_id: projectId,
            name: 'Product help',
            message: null,
          }),
        });
        const sessionJson = await sessionResp.json().catch(() => ({}));
        if (!sessionResp.ok || !sessionJson?.success) {
          throw new Error(sessionJson?.error || 'Failed to start help chat session');
        }

        const sessionId =
          sessionJson.data?.session_id ||
          sessionJson.data?.session?.session_id ||
          null;
        if (!sessionId) throw new Error('No session id returned');

        if (!cancelled) {
          navigate(`/p/${projectId}/c/${sessionId}`, { replace: true });
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Unable to open help chat');
          setLoading(false);
        }
      }
    })();
    return () => { cancelled = true; };
  }, [navigate]);

  if (loading && !error) {
    return (
      <div className="help-chat-page">
        <p><i className="fas fa-spinner fa-spin" aria-hidden="true" /> Opening {projectName}…</p>
      </div>
    );
  }

  return (
    <div className="help-chat-page">
      <h2>Ask Zagger</h2>
      {error ? (
        <>
          <p style={{ color: '#b91c1c' }}>{error}</p>
          <div className="help-chat-actions">
            <button type="button" className="btn" onClick={() => window.location.reload()}>
              Retry
            </button>
            <button type="button" className="btn ghost" onClick={() => navigate('/help/docs')}>
              Browse documentation
            </button>
          </div>
        </>
      ) : null}
    </div>
  );
}

export default HelpChatPage;
